import BlogOrCaseStudy, { BlogOrCaseStudyContent } from "@components/BlogOrCaseStudy";
import GetStartedSection from "@components/GetStartedSection";
import PageMainTitleCard from "@components/LandingPageComponents/PageMainTitleCard";
import WatchDemoForm from "@components/WatchDemoForm";
import BookDemoButton from "@components/Webinar/BookDemoButton";
import ClientLogos from "@components/new-ui/ClientLogos";
import NewLayout from "@components/new-ui/Layout";
import Image from "next/image";
import React, { useRef } from "react";

const BlogOrCaseStudyInput: BlogOrCaseStudyContent[] = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/hugg/hugg-og.png",
        bannerTitle: "Maximizing Conversions and Streamlining Support: Hugg's Transformation with Gallabox",
        bannerDescription: "Here's the awe-inspiring tale of how Hugg boosted efficiency, enhanced customer support, and multiplied conversion rates with Gallabox.",
        redirectUrl: "/case-study/hugg",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/qatar-insurance-company/qatar-og.png",
        bannerTitle: "How Qatar Insurance Company Doubled Lead Generation with Gallabox",
        bannerDescription: "Here's the awe-inspiring tale of how Qatar Insurance Company boosted lead generation, customer satisfaction, and automated responses with Gallabox.",
        redirectUrl: "/case-study/qatar-insurance-company",
    },
];

const BookDemo: React.FC = () => {
    const formRef = useRef<HTMLDivElement>(null);
    return (
        <NewLayout
            title="Gallabox WhatsApp Automation Free Demo | Know how it works"
            description="Learn how Gallabox can boost your business growth. Watch free demo today"
            canonical="https://gallabox.com/watch-demo"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/watch-demo/watch-demo-og.png" }}
        >
            <div style={{ background: "linear-gradient(180deg, #F0F8FF 0.15%, #FFF 40.68%)" }}>
                <PageMainTitleCard
                    mainTitle={
                        <h1 className="lg:text-5xl lg:font-bold text-4xl" style={{ color: "#3364FA" }}>
                            What is Gallabox? 🤔
                        </h1>
                    }
                    description="Gallabox empowers businesses to streamline Whatsapp interactions with powerful features. But seeing is believing. Before you hop on a call with our
                                expert, explore Gallabox's features here."
                    primaryButton={
                        <div className="flex md:gap-6 gap-3 ">
                            <button
                                className="px-4 border py-2 border-solid border-blue-500  text-blue-500 bg-white rounded-md hover:no-underline focus:outline-none hover:shadow-2xl text-base font-medium flex items-center"
                                onClick={() => {
                                    formRef.current?.scrollIntoView({ behavior: "smooth" });
                                }}
                            >
                                <span className="flex gap-2 items-center justify-center">
                                    <Image width={20} height={20} src="/playbtn.png" alt="play icon" />
                                    Watch Demo
                                </span>
                            </button>
                            <BookDemoButton className="py-4" />
                        </div>
                    }
                    mediaType="image"
                    mediaUrl="https://assets.gallabox.com/gb-home/watch-demo/watch-demo-hero-image.png"
                    showKeyFeatures={true}
                />

                <div className="lg:max-w-7xl mx-auto lg:mb-32 lg:mt-0 mt-20 mb-28">
                    <h3 className="text-base text-center font-normal py-2">
                        Trusted by <span className="font-bold">10,000+ Businesses Globally</span>
                    </h3>
                    <ClientLogos />
                </div>
                <section className="my-20" ref={formRef}>
                    <WatchDemoForm />
                </section>
                <GetStartedSection variant="light" />
                <BlogOrCaseStudy
                    mainTitle="Why Fast-Growing Businesses Love Gallabox"
                    mainDescription="Take a look at the accolades and awards Gallabox has scored from G2 as proof of the love customers have for our product."
                    bannerContent={BlogOrCaseStudyInput}
                />
            </div>
        </NewLayout>
    );
};

export default BookDemo;
